import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "st-paper-plane",
  "use": "st-paper-plane-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"st-paper-plane\"><path d=\"M16 2l-16 24 12.4-1.6 3.6 5.6 3.6-5.6 12.4 1.6-16-24zM16 26.4l-1.4-2.2-0.6-0.8 2-17.4 2 17.4-2 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol